import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { filter } from 'rxjs/operators';
import { getPaymentTermWithPreloadedOrder } from '../../selectors/one-click-payments.selector';
import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';

export namespace OneClickPaymentTermDescProvider {
  export class PaymentBuilder extends BaseAsyncValue<string> {
    getValue(): Observable<string> {
      return this.store.select(getPaymentTermWithPreloadedOrder(this.mapItem['index'])).pipe(
        filter(({ preloadedOrder }) => !!preloadedOrder),
        map(({ preloadedOrder }) => `${preloadedOrder.items[this.mapItem['index']].paymentTerm.paymentTermDesc}`),
      );
    }
  }
}
